import { AfterViewChecked, Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { FAZILService, User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { environment } from 'src/environments/environment';
import { validateDNIPattern } from 'src/app/shared/helpers';
import { ServiciosService } from 'src/app/servicios/servicios.service';
import { SubjectCustomer } from '../modelo/SubjectCustomer'
import { Product } from '../modelo/Product';
import { AppComponent } from '../app.component';

import { PageOptions } from '../core/models/pagination';
import { FazilController } from '../core/fazil-controller-component';
import { AdministracionService } from '../administracion/administracion.service';
import { FormBuilder } from '@angular/forms';
import { ProductoOutput } from '../core/models/producto.model';
import { Establishment } from '../modelo/Establishment';
import { EmissionPoint } from '../modelo/EmissionPoint';

@Component({
    selector: 'app-producto',
    templateUrl: './producto.component.html',
    styleUrls: ['./servicios.component.scss']
})
export class ProductoComponent extends FazilController  implements OnInit,  AfterViewChecked, OnChanges {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    _producto: Product = new Product();

    //Variables auxiliares
    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    buttonsActions: any[] = [];

    iva12: boolean = true;


    enEdicion: boolean = false;
    
    //interacción con el popup
    _mostrarEditor: boolean = false;
    
    @Output() productoGuardado = new EventEmitter<ProductoOutput>();
    
    @Input() estaCargandoDatos: boolean = false;
    
    productTypes: any[] = [];
    productType: any;
    
    visible:boolean = false;
    
    establishment: Establishment = new Establishment();
    emissionPointSelected: EmissionPoint = new EmissionPoint();

     
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private confirmationService: ConfirmationService,
        private serviciosService: ServiciosService,
        public override uiService: UIService,
        public override messageService: MessageService,
        public override administracionService: AdministracionService,
        public override _formBuilder: FormBuilder
    ) {
        super(uiService, messageService, administracionService, _formBuilder);
    }
    
    ngOnInit(): void {
        this.initComponent()
        
        this.userService.establishment.subscribe(
            (data) => {
                this.establishment = data;
            }
        );
        this.userService.emissionPoint.subscribe(
            (data) => {
                this.emissionPointSelected = data;
            }
        );
    }
    
    ngAfterViewChecked(): void {
        //dummy
    }
    
    //Detecta los cambios desde fuera del componente
    ngOnChanges(changes: SimpleChanges): void {
        this.visible = (this.mostrarEditor && this.producto !== null);
    } 
    
    async initComponent() {
        
        this.estaCargandoDatos = false;
        this.productTypes = this.appConfig.properties.productTypes;
    }
    
    //Accesores
    @Input() 
    set mostrarEditor(v){
        this._mostrarEditor = v;
    }
    
    get mostrarEditor(){
        return this._mostrarEditor;
    }
    
    @Input()
    set producto(v) {
        if (v){
            this._producto = v;
            if (this._producto.productType){
                this.productType = this.productTypes.find(x => x.value == this._producto.productType);
            }
        }
    }
    get producto() {
        return this._producto;
    }


    guardarServicio(): void {

        this.ui.limpiarMessages();
        if (this.iva12) {
            this._producto.taxType = '2'; //TABLA 17. IVA 
            this._producto.taxFactor = this.appConfig.app.iva.factor; 
        } else {
            this._producto.taxType = '2';  //TABLA 17. IVA con porcentaje 0
            this._producto.taxFactor = 0; 
        }
        
        this._producto.productType = this.productType.value;
        this._producto.estab = this.establishment.name;
        this._producto.photo = null;

        if (this._producto) {
            //Guardar producto en persistencia
            this.serviciosService.enviarProducto(this._producto).subscribe(
                async (data) => {
                    this._producto = data;
                    this._producto.amount = 1;
                    this.cerrarPopup(true);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    onKey(event: KeyboardEvent) {
        this.ui.limpiarMessages();
    }

    cerrarPopup(guardado:boolean){
        this.visible = false;
        let mensaje = "Se cierra la venta de edición.";
        if ( guardado ){
            this.enEdicion = false;
            mensaje = "Se registró el Producto/Servicio con éxito.";
        }
        this.productoGuardado.emit({
              data: this._producto,
              success: guardado,
              message: mensaje,
            });
    }
    
}
